// @ts-check

import './bootstrap';

// jQuery
import 'jquery';

import './date-picker';
import './input-number';
import './map';
import './sliders';
import Cookie from './cookie';
import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import toInteger from 'lodash/toInteger';

/*
 * Adds the class `loaded` on document load
 */
window.addEventListener('load', () => {
    document.body.classList.add('loaded');
});

/*
* Init Cookie Banner
*/
new Cookie('.cookie-banner');


$(function () {
    // Header Scrolling
    var previousScrollTop = 0;
    var $header = $('.header');
    var $homeHeader = $('.home-page').find($header);

    var $scrollTopButton = $('.btn-scroll-top').on('click', () => {
        $('html, body').animate({ scrollTop: 0 });
    });

    if(document.getElementById("min-price-range")) {
        var slider = document.getElementById('slider');
        var minPrice = document.getElementById("min-price-range");
        var maxPrice = document.getElementById("max-price-range");
        var prices = [minPrice, maxPrice];

        noUiSlider.create(slider, {
            start: [minPrice.value, maxPrice.value],
            connect: true,
            range: {
                'min': [0],
                'max': [30000]
            }
        });

        slider.noUiSlider.on('update', function (values, handle) {
            prices[handle].value = toInteger(values[handle]);

            prices[handle].dispatchEvent(new InputEvent('input'));
        });
    }

    $(window).on('scroll', () => {
        var scrollTop = $(window).scrollTop();
        var height = $header.innerHeight();

        let currentScrollTop = scrollTop;
        let isScrollingDown = previousScrollTop < currentScrollTop;
        let isScrollingUp = previousScrollTop > currentScrollTop;
        let headerIsInvisible = scrollTop > height;

        if (isScrollingDown && headerIsInvisible) {
            $header.addClass("scrollUp");

            $homeHeader.removeClass("bg-dark");
        } else if (isScrollingUp) {
            if (headerIsInvisible) {
                $header.removeClass("scrollUp");

                $homeHeader.addClass('bg-dark');
            } else {
                $homeHeader.removeClass("bg-dark");
            }
        }

        $scrollTopButton.toggleClass('d-none', currentScrollTop < $scrollTopButton.data('scroll'));

        previousScrollTop = currentScrollTop;
    });

    $('.mini-menu').on('click', 'a', (event) => {
        event.preventDefault();

        let section = $(event.target).attr('href');

        $('html, body').animate({ scrollTop: $(section).offset().top - 50 });
    });

    /** @type {JQuery<HTMLDivElement>} */
    const $filtersModal = $('#filtersModal');

    $filtersModal.on('submit', '#filtersModalForm', () => {
        $filtersModal.modal('hide');
    }).on('click', '#clearFilters', () => {
        $filtersModal.find(':input[type="number"]').each((index, input) => {
            input.value = '';
            input.dispatchEvent(new InputEvent('input'));
        });

        $filtersModal.find('#min-price-range').each((index, input) => {
            input.value = 0;
            input.dispatchEvent(new Event('change'));
        });

        $filtersModal.find('#max-price-range').each((index, input) => {
            input.value = 30000;
            input.dispatchEvent(new Event('change'));
        });

        $filtersModal.find('#filter-location-all, #filter-area-all, #filter-price-desc').each((index, input) => {
            $(input).prop('checked', true);
            input.dispatchEvent(new Event('change'));
        });

        $filtersModal.find(':input[name^="amenities"]').each((index, input) => {
            $(input).prop('checked', false);
            input.dispatchEvent(new Event('change'));
        });
    });

    /** @type {JQuery<HTMLDivElement>} */
    const $guestsModal = $('#guestsModal');

    $guestsModal.on('submit', '#guestsModalForm', () => {
        $guestsModal.modal('hide');
    }).on('reset', '#guestsModalForm', () => {
        $guestsModal.find(':input[type="number"]').each((index, input) => {
            input.dispatchEvent(new InputEvent('input'));
        });
    });

    $('#sortModalForm').on('submit', () => {
        $('#sortModal').modal('hide');
    });

    const $contactModal = $('#contactModal').on('show.bs.modal', (e) => {
        $contactModal.find('input[name="request[checkin]"]').val($('input[name="checkin"]').val());
        $contactModal.find('input[name="request[checkout]"]').val($('input[name="checkout"]').val());
        $contactModal.find('input[name="request[adults]"]').val($('input[name="adults"]').val());
        $contactModal.find('input[name="request[children]"]').val($('input[name="children"]').val());
        $contactModal.find('input[name="request[infants]"]').val($('input[name="infants"]').val());
    });

    $('[data-toggle="copy"]').on('click', (e) => {
        const $target = $($(e.target).data('target'));
        $target.trigger('select');
        document.execCommand('copy');
    });

    // Listen to keydown events on the input field.
    if(prices){
        prices.forEach(function (input, handle) {

            input.addEventListener('change', function () {
                slider.noUiSlider.setHandle(handle, this.value);
            });
        });
    }
});

// https://stackoverflow.com/a/13123626/935726
window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload();
    }
}


